var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progressContainer"},[_c('div',{staticClass:"progress",style:({
      height: `${_vm.percentage === '-' ? 100 : _vm.percentage}%`,
      background: _vm.nodata ? '#ddd' : '#FFC06A'
    })})])
}
var staticRenderFns = []

export { render, staticRenderFns }